export const ROUTE_PATH = '/profile';
